(function() {
  "use strict";
  try {
    if (typeof document != "undefined") {
      var elementStyle = document.createElement("style");
      elementStyle.appendChild(document.createTextNode(".clay-quantity-grid-table-container {\n  width: 100%;\n}\n\n.clay-quantity-grid-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  /* font-size: 13px; */\n  border: 1px solid #242833bf;\n  margin-bottom: 8px;\n  margin-top: 12px;\n}\n\n.clay-quantity-grid-table thead th {\n  border-bottom: 1px solid #242833bf;\n  padding: 8px;\n  text-align: left;\n  font-weight: normal;\n  /* background-color: #f0f0f0; */\n}\n\n.clay-quantity-grid-table tbody td {\n  padding: 8px;\n  border-bottom: 1px solid #242833bf;\n}\n\n.clay-quantity-grid-table tbody tr:last-child td {\n  border-bottom: none;\n}"));
      document.head.appendChild(elementStyle);
    }
  } catch (e) {
    console.error("vite-plugin-css-injected-by-js", e);
  }
})();
!function() {
  "use strict";
  "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout;
  const e = async ({ shopDomain: e2, accessToken: r2, query: t2, variables: n2 }) => {
    try {
      const o2 = `https://${e2}/api/2024-07/graphql.json`, a2 = { "X-Shopify-Storefront-Access-Token": r2, "Content-Type": "application/json" }, i2 = await fetch(o2, { method: "POST", headers: a2, body: JSON.stringify({ query: t2, variables: n2 }) });
      return await i2.json();
    } catch (e3) {
      throw console.log("error", e3), e3;
    }
  };
  function r(e2) {
    if (!Array.isArray(e2) || 0 === e2.length) return [];
    const r2 = e2[0];
    return "customerGroupId" in r2 ? (t2 = e2, Array.isArray(t2) ? t2.map((e3 = {}) => {
      const { customerGroupId: r3 = "", customerTag: t3 = "", type: n2 = "WHOLESALE", wholesalePrice: o2 = null, quantityPrice: a2 = {} } = e3;
      let i2 = false;
      "QUANTITY" === n2 && (i2 = !!a2.isVariantUnique);
      let c2 = [];
      return "WHOLESALE" === n2 && null != o2 ? c2.push({ quantity: "1", price: o2 }) : Array.isArray(a2.value) && (c2 = a2.value), { customerGroupId: r3, customerTag: t3, markets: [{ handle: "", currency: "", pricing: { type: c2.length > 1 ? "QUANTITY" : "WHOLESALE", strategy: "A", isVariantUnique: i2, priceSource: "R", values: c2 } }] };
    }) : []) : "i" in r2 ? function(e3) {
      if (!e3 || !Array.isArray(e3)) return null;
      return e3.map((e4 = {}) => {
        let [r3 = "", t3 = ""] = (e4.i || "").split("~");
        return { customerGroupId: r3, customerTag: t3, markets: e4.p.split("|").map((e5) => {
          let [r4 = "", t4 = "", n2 = "A", o2 = "0", a2 = "R", i2 = ""] = e5.split("~"), c2 = i2.split(";").map((e6) => {
            let [r5 = "1", t5 = "0"] = e6.split(":");
            return { quantity: r5, price: t5 };
          }) ?? [];
          return { handle: r4, currency: t4, pricing: { type: c2.length > 1 ? "QUANTITY" : "WHOLESALE", strategy: n2, priceSource: a2, isVariantUnique: "1" === o2, values: c2 } };
        }) };
      });
    }(e2) : [];
    var t2;
  }
  function t(e2) {
    let r2 = null;
    const t2 = e2.match(/\/products\/([^/?#]+)/);
    return t2 && t2[1] && (r2 = decodeURIComponent(t2[1])), r2;
  }
  async function n(t2) {
    const n2 = window.clayStorefrontConfig || {}, o2 = window.clayCustomerTier || {}, a2 = window.clayCustomerTags || [], i2 = window.clayCountryIsoCode, { allVariants: c2 } = await (async (t3, n3, o3, a3, i3, c3) => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
      try {
        let s2, l2 = true, u2 = [];
        for (; l2; ) {
          const p2 = await e({ shopDomain: t3, accessToken: n3, query: `query fetchProductVariantMetafield($handle: String!, $country: CountryCode) @inContext(country: $country){
                    product(handle: $handle) {
                        title
                        handle
                        variants(first: 250,after: ${s2 ? `"${s2}"` : "null"}){
                            edges{
                                node{
                                    id
                                    title
                                    metafield(namespace: "app--173437812737--clay", key: "pricing_rule"){
                                        value
                                        type
                                    }
                                    price{
                                      amount
                                      currencyCode
                                    }
                                    compareAtPrice{
                                      amount
                                      currencyCode
                                    }
                                }
                            }
                            pageInfo{
                                hasNextPage
                                endCursor
                            }
                        }
                    }
                }`, variables: { handle: o3, country: c3 } });
          if (!((_a = p2.data) == null ? void 0 : _a.product)) return l2 = false, console.log("No products found"), [];
          const d2 = (_d = (_c = (_b = p2.data) == null ? void 0 : _b.product) == null ? void 0 : _c.variants) == null ? void 0 : _d.edges.map((e2) => {
            var _a2;
            const t4 = e2.node, n4 = t4.id.split("/").pop(), o4 = (_a2 = t4.metafield) == null ? void 0 : _a2.value, c4 = r("string" == typeof o4 ? JSON.parse(o4) : []);
            let s3 = c4.find((e3) => e3.customerGroupId === a3 || i3.includes(e3.customerTag));
            s3 || (s3 = c4.find((e3) => "ALL" === e3.customerGroupId));
            const l3 = window.clayMarketHandle;
            if (window.clayCountryCurrency, s3) {
              let e3 = s3.markets.find((e4) => e4.handle === l3 || "" === e4.handle) || null;
              if (e3) {
                const r2 = { ...s3, markets: [e3] };
                return { id: n4, title: t4.title, pricingRule: r2, price: t4.price, compareAtPrice: t4.compareAtPrice };
              }
            }
            return { id: n4, title: t4.title, pricingRule: null, price: t4.price, compareAtPrice: t4.compareAtPrice };
          });
          u2.push(...d2), l2 = (_h = (_g = (_f = (_e = p2.data) == null ? void 0 : _e.product) == null ? void 0 : _f.variants) == null ? void 0 : _g.pageInfo) == null ? void 0 : _h.hasNextPage, s2 = (_l = (_k = (_j = (_i = p2.data) == null ? void 0 : _i.product) == null ? void 0 : _j.variants) == null ? void 0 : _k.pageInfo) == null ? void 0 : _l.endCursor;
        }
        return { handle: o3, allVariants: u2 };
      } catch (e2) {
        throw console.error("Error fetching product metafield:", e2), e2;
      }
    })(n2.shopDomain, n2.token, t2, "" === o2.customerGroupId ? "LOGGED_IN" : o2.customerGroupId, a2, i2);
    return c2;
  }
  const o = "%[a-f0-9]{2}", a = new RegExp("(" + o + ")|([^%]+?)", "gi"), i = new RegExp("(" + o + ")+", "gi");
  function c(e2, r2) {
    try {
      return [decodeURIComponent(e2.join(""))];
    } catch {
    }
    if (1 === e2.length) return e2;
    r2 = r2 || 1;
    const t2 = e2.slice(0, r2), n2 = e2.slice(r2);
    return Array.prototype.concat.call([], c(t2), c(n2));
  }
  function s(e2) {
    try {
      return decodeURIComponent(e2);
    } catch {
      let r2 = e2.match(a) || [];
      for (let t2 = 1; t2 < r2.length; t2++) r2 = (e2 = c(r2, t2).join("")).match(a) || [];
      return e2;
    }
  }
  function l(e2) {
    if ("string" != typeof e2) throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof e2 + "`");
    try {
      return decodeURIComponent(e2);
    } catch {
      return function(e3) {
        const r2 = { "%FE%FF": "��", "%FF%FE": "��" };
        let t2 = i.exec(e3);
        for (; t2; ) {
          try {
            r2[t2[0]] = decodeURIComponent(t2[0]);
          } catch {
            const e4 = s(t2[0]);
            e4 !== t2[0] && (r2[t2[0]] = e4);
          }
          t2 = i.exec(e3);
        }
        r2["%C2"] = "�";
        const n2 = Object.keys(r2);
        for (const t3 of n2) e3 = e3.replace(new RegExp(t3, "g"), r2[t3]);
        return e3;
      }(e2);
    }
  }
  function u(e2, r2) {
    const t2 = {};
    if (Array.isArray(r2)) for (const n2 of r2) {
      const r3 = Object.getOwnPropertyDescriptor(e2, n2);
      (r3 == null ? void 0 : r3.enumerable) && Object.defineProperty(t2, n2, r3);
    }
    else for (const n2 of Reflect.ownKeys(e2)) {
      const o2 = Object.getOwnPropertyDescriptor(e2, n2);
      if (o2.enumerable) {
        r2(n2, e2[n2], e2) && Object.defineProperty(t2, n2, o2);
      }
    }
    return t2;
  }
  function p(e2, r2) {
    if ("string" != typeof e2 || "string" != typeof r2) throw new TypeError("Expected the arguments to be of type `string`");
    if ("" === e2 || "" === r2) return [];
    const t2 = e2.indexOf(r2);
    return -1 === t2 ? [] : [e2.slice(0, t2), e2.slice(t2 + r2.length)];
  }
  const d = Symbol("encodeFragmentIdentifier");
  function y(e2) {
    if ("string" != typeof e2 || 1 !== e2.length) throw new TypeError("arrayFormatSeparator must be single character string");
  }
  function f(e2, r2) {
    return r2.encode ? r2.strict ? encodeURIComponent(e2).replaceAll(/[!'()*]/g, (e3) => `%${e3.charCodeAt(0).toString(16).toUpperCase()}`) : encodeURIComponent(e2) : e2;
  }
  function m(e2, r2) {
    return r2.decode ? l(e2) : e2;
  }
  function g(e2) {
    return Array.isArray(e2) ? e2.sort() : "object" == typeof e2 ? g(Object.keys(e2)).sort((e3, r2) => Number(e3) - Number(r2)).map((r2) => e2[r2]) : e2;
  }
  function h(e2) {
    const r2 = e2.indexOf("#");
    return -1 !== r2 && (e2 = e2.slice(0, r2)), e2;
  }
  function F(e2, r2, t2) {
    return "string" === t2 && "string" == typeof e2 ? e2 : "function" == typeof t2 && "string" == typeof e2 ? t2(e2) : !r2.parseBooleans || null === e2 || "true" !== e2.toLowerCase() && "false" !== e2.toLowerCase() ? "number" !== t2 || Number.isNaN(Number(e2)) || "string" != typeof e2 || "" === e2.trim() ? r2.parseNumbers && !Number.isNaN(Number(e2)) && "string" == typeof e2 && "" !== e2.trim() ? Number(e2) : e2 : Number(e2) : "true" === e2.toLowerCase();
  }
  function b(e2) {
    const r2 = (e2 = h(e2)).indexOf("?");
    return -1 === r2 ? "" : e2.slice(r2 + 1);
  }
  function A(e2, r2) {
    y((r2 = { decode: true, sort: true, arrayFormat: "none", arrayFormatSeparator: ",", parseNumbers: false, parseBooleans: false, types: /* @__PURE__ */ Object.create(null), ...r2 }).arrayFormatSeparator);
    const t2 = function(e3) {
      let r3;
      switch (e3.arrayFormat) {
        case "index":
          return (e4, t3, n3) => {
            r3 = /\[(\d*)]$/.exec(e4), e4 = e4.replace(/\[\d*]$/, ""), r3 ? (void 0 === n3[e4] && (n3[e4] = {}), n3[e4][r3[1]] = t3) : n3[e4] = t3;
          };
        case "bracket":
          return (e4, t3, n3) => {
            r3 = /(\[])$/.exec(e4), e4 = e4.replace(/\[]$/, ""), r3 ? void 0 !== n3[e4] ? n3[e4] = [...n3[e4], t3] : n3[e4] = [t3] : n3[e4] = t3;
          };
        case "colon-list-separator":
          return (e4, t3, n3) => {
            r3 = /(:list)$/.exec(e4), e4 = e4.replace(/:list$/, ""), r3 ? void 0 !== n3[e4] ? n3[e4] = [...n3[e4], t3] : n3[e4] = [t3] : n3[e4] = t3;
          };
        case "comma":
        case "separator":
          return (r4, t3, n3) => {
            const o2 = "string" == typeof t3 && t3.includes(e3.arrayFormatSeparator), a2 = "string" == typeof t3 && !o2 && m(t3, e3).includes(e3.arrayFormatSeparator);
            t3 = a2 ? m(t3, e3) : t3;
            const i2 = o2 || a2 ? t3.split(e3.arrayFormatSeparator).map((r5) => m(r5, e3)) : null === t3 ? t3 : m(t3, e3);
            n3[r4] = i2;
          };
        case "bracket-separator":
          return (r4, t3, n3) => {
            const o2 = /(\[])$/.test(r4);
            if (r4 = r4.replace(/\[]$/, ""), !o2) return void (n3[r4] = t3 ? m(t3, e3) : t3);
            const a2 = null === t3 ? [] : m(t3, e3).split(e3.arrayFormatSeparator);
            void 0 !== n3[r4] ? n3[r4] = [...n3[r4], ...a2] : n3[r4] = a2;
          };
        default:
          return (e4, r4, t3) => {
            void 0 !== t3[e4] ? t3[e4] = [...[t3[e4]].flat(), r4] : t3[e4] = r4;
          };
      }
    }(r2), n2 = /* @__PURE__ */ Object.create(null);
    if ("string" != typeof e2) return n2;
    if (!(e2 = e2.trim().replace(/^[?#&]/, ""))) return n2;
    for (const o2 of e2.split("&")) {
      if ("" === o2) continue;
      const e3 = r2.decode ? o2.replaceAll("+", " ") : o2;
      let [a2, i2] = p(e3, "=");
      void 0 === a2 && (a2 = e3), i2 = void 0 === i2 ? null : ["comma", "separator", "bracket-separator"].includes(r2.arrayFormat) ? i2 : m(i2, r2), t2(m(a2, r2), i2, n2);
    }
    for (const [e3, t3] of Object.entries(n2)) if ("object" == typeof t3 && null !== t3 && "string" !== r2.types[e3]) for (const [n3, o2] of Object.entries(t3)) {
      const a2 = r2.types[e3] ? r2.types[e3].replace("[]", "") : void 0;
      t3[n3] = F(o2, r2, a2);
    }
    else "object" == typeof t3 && null !== t3 && "string" === r2.types[e3] ? n2[e3] = Object.values(t3).join(r2.arrayFormatSeparator) : n2[e3] = F(t3, r2, r2.types[e3]);
    return false === r2.sort ? n2 : (true === r2.sort ? Object.keys(n2).sort() : Object.keys(n2).sort(r2.sort)).reduce((e3, r3) => {
      const t3 = n2[r3];
      return e3[r3] = Boolean(t3) && "object" == typeof t3 && !Array.isArray(t3) ? g(t3) : t3, e3;
    }, /* @__PURE__ */ Object.create(null));
  }
  function w(e2, r2) {
    if (!e2) return "";
    y((r2 = { encode: true, strict: true, arrayFormat: "none", arrayFormatSeparator: ",", ...r2 }).arrayFormatSeparator);
    const t2 = (t3) => r2.skipNull && null == e2[t3] || r2.skipEmptyString && "" === e2[t3], n2 = function(e3) {
      switch (e3.arrayFormat) {
        case "index":
          return (r3) => (t3, n3) => {
            const o3 = t3.length;
            return void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? t3 : null === n3 ? [...t3, [f(r3, e3), "[", o3, "]"].join("")] : [...t3, [f(r3, e3), "[", f(o3, e3), "]=", f(n3, e3)].join("")];
          };
        case "bracket":
          return (r3) => (t3, n3) => void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? t3 : null === n3 ? [...t3, [f(r3, e3), "[]"].join("")] : [...t3, [f(r3, e3), "[]=", f(n3, e3)].join("")];
        case "colon-list-separator":
          return (r3) => (t3, n3) => void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? t3 : null === n3 ? [...t3, [f(r3, e3), ":list="].join("")] : [...t3, [f(r3, e3), ":list=", f(n3, e3)].join("")];
        case "comma":
        case "separator":
        case "bracket-separator": {
          const r3 = "bracket-separator" === e3.arrayFormat ? "[]=" : "=";
          return (t3) => (n3, o3) => void 0 === o3 || e3.skipNull && null === o3 || e3.skipEmptyString && "" === o3 ? n3 : (o3 = null === o3 ? "" : o3, 0 === n3.length ? [[f(t3, e3), r3, f(o3, e3)].join("")] : [[n3, f(o3, e3)].join(e3.arrayFormatSeparator)]);
        }
        default:
          return (r3) => (t3, n3) => void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? t3 : null === n3 ? [...t3, f(r3, e3)] : [...t3, [f(r3, e3), "=", f(n3, e3)].join("")];
      }
    }(r2), o2 = {};
    for (const [r3, n3] of Object.entries(e2)) t2(r3) || (o2[r3] = n3);
    const a2 = Object.keys(o2);
    return false !== r2.sort && a2.sort(r2.sort), a2.map((t3) => {
      const o3 = e2[t3];
      return void 0 === o3 ? "" : null === o3 ? f(t3, r2) : Array.isArray(o3) ? 0 === o3.length && "bracket-separator" === r2.arrayFormat ? f(t3, r2) + "[]" : o3.reduce(n2(t3), []).join("&") : f(t3, r2) + "=" + f(o3, r2);
    }).filter((e3) => e3.length > 0).join("&");
  }
  function S(e2, r2) {
    var _a;
    r2 = { decode: true, ...r2 };
    let [t2, n2] = p(e2, "#");
    return void 0 === t2 && (t2 = e2), { url: ((_a = t2 == null ? void 0 : t2.split("?")) == null ? void 0 : _a[0]) ?? "", query: A(b(e2), r2), ...r2 && r2.parseFragmentIdentifier && n2 ? { fragmentIdentifier: m(n2, r2) } : {} };
  }
  function P(e2, r2) {
    r2 = { encode: true, strict: true, [d]: true, ...r2 };
    const t2 = h(e2.url).split("?")[0] || "";
    let n2 = w({ ...A(b(e2.url), { sort: false }), ...e2.query }, r2);
    n2 && (n2 = `?${n2}`);
    let o2 = function(e3) {
      let r3 = "";
      const t3 = e3.indexOf("#");
      return -1 !== t3 && (r3 = e3.slice(t3)), r3;
    }(e2.url);
    if ("string" == typeof e2.fragmentIdentifier) {
      const n3 = new URL(t2);
      n3.hash = e2.fragmentIdentifier, o2 = r2[d] ? n3.hash : `#${e2.fragmentIdentifier}`;
    }
    return `${t2}${n2}${o2}`;
  }
  function v(e2, r2, t2) {
    t2 = { parseFragmentIdentifier: true, [d]: false, ...t2 };
    const { url: n2, query: o2, fragmentIdentifier: a2 } = S(e2, t2);
    return P({ url: n2, query: u(o2, r2), fragmentIdentifier: a2 }, t2);
  }
  const k = Object.freeze(Object.defineProperty({ __proto__: null, exclude: function(e2, r2, t2) {
    return v(e2, Array.isArray(r2) ? (e3) => !r2.includes(e3) : (e3, t3) => !r2(e3, t3), t2);
  }, extract: b, parse: A, parseUrl: S, pick: v, stringify: w, stringifyUrl: P }, Symbol.toStringTag, { value: "Module" }));
  async function j() {
    t(window.location.href) && x(0, 3e3), N(0, 1e4);
  }
  function x(e2, r2) {
    !async function() {
      const e3 = document.querySelector(".product-info .price");
      if (!e3) return;
      if (e3.querySelector(".clay-tax-breakdown")) return;
      let r3 = t(window.location.href);
      const o2 = await n(r3), a2 = new URL(window.location.href);
      let i2 = k.parse(a2.search).variant;
      i2 || (i2 = o2[0].id);
      const c2 = o2.find((e4) => e4.id === i2);
      if (!c2.pricingRule) return;
      const { retailPrice: s2 } = I(c2, 1), l2 = (parseFloat(s2) / 1.27).toFixed(2), u2 = (parseFloat(s2) - parseFloat(l2)).toFixed(2), p2 = document.createElement("div");
      p2.className = "clay-tax-breakdown", p2.style.fontSize = "0.9em", p2.style.color = "#666", p2.innerHTML = `${l2} Ft nettó + ${u2} Ft áfa`;
      const d2 = e3.querySelector(".clay-savings-text-container");
      d2 && e3.insertBefore(p2, d2);
    }(), e2 < r2 && setTimeout(() => {
      x(e2 + 500, r2);
    }, 500);
  }
  function N(e2, r2, o2) {
    let a2 = document.querySelectorAll("product-card");
    !function(e3) {
      e3.forEach(async (e4, r3) => {
        let o3 = t(e4.querySelector(".js-product-link").href);
        !async function(e5, r4) {
          e5.sort((e6, r5) => parseFloat(e6.price.amount) - parseFloat(r5.price.amount));
          const t2 = e5[0];
          if (!t2.pricingRule) return;
          const n2 = r4.querySelector(".price");
          if (!n2) return;
          const { retailPrice: o4 } = I(t2, 1), a3 = (parseFloat(o4) / 1.27).toFixed(2), i2 = (parseFloat(o4) - parseFloat(a3)).toFixed(2), c2 = document.createElement("div");
          c2.className = "clay-tax-breakdown", c2.style.fontSize = "0.9em", c2.style.color = "#666", c2.innerHTML = `${a3} Ft nettó + ${i2} Ft áfa`, r4.querySelector(".clay-tax-breakdown") || n2.appendChild(c2);
        }(await n(o3), e4);
      });
    }(a2), e2 < r2 && setTimeout(() => {
      N(e2 + 500, r2, a2.length);
    }, 500);
  }
  function I(e2, r2) {
    var _a;
    let t2 = "", n2 = "", o2 = ((_a = e2.pricingRule) == null ? void 0 : _a.markets[0]) ?? null;
    if (!o2) return { retailPrice: "", compareAtPrice: "" };
    let a2 = o2.pricing.type;
    return "QUANTITY" === a2 ? { retailPrice: t2, compareAtPrice: n2 } = function(e3, r3, t3) {
      let n3 = t3.pricing.strategy, o3 = t3.pricing.values, a3 = t3.currency, i2 = e3.price.currencyCode, c2 = "R" === t3.pricing.priceSource ? e3.price.amount : e3.compareAtPrice.amount, s2 = window.marketConversionRate;
      if (!c2 || "" === c2) return { retailPrice: "", compareAtPrice: "" };
      let l2 = o3.filter((e4) => Number(e4.quantity) <= r3).reduce((e4, r4) => Number(r4.quantity) > Number(e4.quantity) ? r4 : e4, { price: "0", quantity: "0" }).price;
      if (a3 !== i2 && "" !== a3) {
        if (!s2 || !s2.conversion_rate) return { retailPrice: "", compareAtPrice: "" };
        ["A", "F"].includes(n3) && (l2 = (parseFloat(l2) * s2.conversion_rate).toFixed(2).toString());
      }
      let u2 = "A" === n3 ? l2 : "P" === n3 ? (parseFloat(c2) * (1 - parseFloat(l2) / 100)).toFixed(2).toString() : "F" === n3 ? (parseFloat(c2) - parseFloat(l2)).toFixed(2).toString() : e3.price.amount;
      if ("" === a3 && s2 && s2.base_currency !== i2) return { retailPrice: "", compareAtPrice: "" };
      (parseFloat(u2) < 0 || parseFloat(u2) > parseFloat(e3.price.amount)) && (u2 = e3.price.amount);
      return { retailPrice: u2, compareAtPrice: c2 };
    }(e2, r2, o2) : "WHOLESALE" === a2 && ({ retailPrice: t2, compareAtPrice: n2 } = function(e3, r3) {
      let t3 = r3.pricing.strategy;
      r3.pricing.values;
      let n3 = r3.currency, o3 = e3.price.currencyCode, a3 = window.marketConversionRate, i2 = "R" === r3.pricing.priceSource ? e3.price.amount : e3.compareAtPrice.amount, c2 = r3.pricing.values[0].price;
      if (!i2 || "" === i2) return { retailPrice: "", compareAtPrice: "" };
      if (n3 !== o3 && "" !== n3) {
        if (!a3 || !a3.conversion_rate) return { retailPrice: "", compareAtPrice: "" };
        ["A", "F"].includes(t3) && (c2 = (parseFloat(c2) * a3.conversion_rate).toFixed(2).toString());
      }
      let s2 = "A" === t3 ? c2 : "P" === t3 ? (parseFloat(i2) * (1 - parseFloat(c2) / 100)).toFixed(2).toString() : "F" === t3 ? (parseFloat(i2) - parseFloat(c2)).toFixed(2).toString() : e3.price.amount;
      if ("" === n3 && a3 && a3.base_currency !== o3) return { retailPrice: "", compareAtPrice: "" };
      (parseFloat(s2) < 0 || parseFloat(s2) > parseFloat(e3.price.amount)) && (s2 = e3.price.amount);
      return { retailPrice: s2, compareAtPrice: i2 };
    }(e2, o2)), { retailPrice: t2, compareAtPrice: n2 };
  }
  !async function() {
    !function() {
      window.addEventListener("popstate", j);
      const e2 = history.pushState;
      history.pushState = function() {
        e2.apply(this, arguments), j();
      };
      const r2 = history.replaceState;
      history.replaceState = function() {
        r2.apply(this, arguments), j();
      }, j();
    }();
  }();
}();
